import {
  Box,
  Checkbox,
  Divider,
  Fade,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { getPuestos } from "../../../helpers/puestos";
import { Loading } from "../../../common/components";

export const ConocimientoPuestos = ({ puestosAcolito, setPuestosAcolito }) => {
  const [puestos, setPuestos] = useState([]);
  const [loading, setLoading] = useState(true);

  const getData = async () => {
    const p = await getPuestos();
    //Crear diccionario clasificando por tipo_ceremonia
    const puestosClasificados = p.reduce((acc, curr) => {
      if (!acc[curr.tipo_ceremonia]) {
        acc[curr.tipo_ceremonia] = [];
      }
      acc[curr.tipo_ceremonia].push(curr);
      return acc;
    }, {});
    setPuestos(puestosClasificados);

    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <Loading texto="Obteniendo información" />;
  }

  return (
    <Fade in={true} timeout={1000}>
      <Box sx={style.modal}>
        <Box
          sx={{
            padding: 5,
            borderRadius: 7,
            //Agregar sombra
            boxShadow: 5,
            width: "50%",
            margin: "auto",
          }}
        >
          <Typography variant="h6" color="primary">
            Conocimiento de puestos
          </Typography>
          <Typography variant="body" color="secondary.dark" fontSize={16}>
            Seleccione los puestos que sabe desempeñar
          </Typography>
          <Box
            sx={
              (style.inputs,
              {
                display: "flex",
                flexDirection: "column",
                marginTop: 2,
              })
            }
          >
            {/* Barrer el diccionario imprimiendo la llave */}
            {Object.keys(puestos).map((tipo_ceremonia) => (
              <Box key={tipo_ceremonia}>
                <Typography
                  color="black"
                  fontWeight={"bold"}
                  fontSize={18}
                  sx={{
                    marginBottom: 1,
                  }}
                >
                  {tipo_ceremonia}
                </Typography>
                <Box
                  sx={{
                    marginBottom: 2,
                  }}
                >
                  {/* Barrer los valores de cada llave */}
                  {puestos[tipo_ceremonia].map((puesto) => (
                    <FormGroup key={puesto.id}>
                      <FormControlLabel
                        control={<Checkbox />}
                        label={puesto.nombre}
                        checked={
                          //Barrer el array de puestos del acolito
                          puestosAcolito.some(
                            (p) => p.ID_puesto === puesto.id
                          ) || false
                        }
                        onChange={(e) => {
                          //Si está marcado, agregar al array de puestos del acolito
                          if (e.target.checked) {
                            setPuestosAcolito([
                              ...puestosAcolito,
                              { ID_puesto: puesto.id },
                            ]);
                          } else {
                            //Si no está marcado, eliminar del array de puestos del acolito
                            setPuestosAcolito(
                              puestosAcolito.filter(
                                (p) => p.ID_puesto !== puesto.id
                              )
                            );
                          }
                        }}
                      />

                      <Divider />
                    </FormGroup>
                  ))}
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

const style = {
  modal: {
    // position: "absolute",
    top: "50%",
    left: "50%",
    // transform: "translate(-50%, -50%)",
    // width: "65%",
    bgcolor: "background.paper",
    // boxShadow: 24,
    p: 4,
    // borderRadius: 2,
  },
  modal_title: {
    textAlign: "center",
    marginBottom: 5,
  },
  inputs: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
    justifyContent: "space-around",
  },
};
